import React, { useState, useEffect } from "react";
const Footer = () => {
  const [flashnews, setFlashNews] = useState("");
  useEffect(() => {
    fetch("https://kvrstarlightmedicalacademy.com/api/scrollmessage.php")
      .then((response) => response.json())
      .then((data) => setFlashNews(data[0].message));
  }, []);
  const announcement = flashnews;
  return (
    <>
      <div>
        <style>{`
      .marquee-wrapper {
        overflow: hidden;
        position: relative;
        white-space: nowrap;
      }

      .marquee-content {
        display: inline-block;
        padding-left: 100%;
        animation: marquee 20s linear infinite;
        color: #0460a4;
      }

      .marquee-wrapper:hover .marquee-content {
        animation-play-state: paused;
      }

      @keyframes marquee {
        0% {
          transform: translateX(0%);
        }
        100% {
          transform: translateX(-100%);
        }
      }
    `}</style>
        <p>
          {announcement && (
            <div className="container-fluid bg-light overflow-hidden">
              <div className="marquee-wrapper" aria-live="polite">
                <div className="marquee-content">
                  <span>{announcement}</span>
                </div>
              </div>
            </div>
          )}
        </p>
      </div>
      <div
        style={{
          backgroundColor: "grey",
          height: "30px",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          fontSize: "12px",
          position: "relative",
          bottom: "0px",
        }}
      >
        <p style={{ margin: "0px" }}>
          © 2025 KVR Startlight Medical Academy. All Rights Reserved.
          <a
            style={{ color: "white", textDecoration: "none" }}
            href="https://www.kkccinfo.com"
          >
            {" "}
            Designed by: SrinivasaRao.K
          </a>
        </p>
      </div>
    </>
  );
};

export default Footer;
